export default [
   
   
      {id:'1',label:'Allergologia ed immunologia clinica'},
      {id:'2',label:'Angiologia'},
      {id:'3',label:'Cardiologia'},
      {id:'4',label:'Dermatologia e venereologia'},
      {id:'5',label:'Ematologia'},
      {id:'6',label:'Endocrinologia'},
      {id:'7',label:'Gastroenterologia'},
      {id:'8',label:'Genetica medica'},
      {id:'9',label:'Geriatria'},
      {id:'10',label:'Malattie metaboliche e diabetologia'},
      {id:'11',label:'Malattie dell\'apparato respiratorio'},
      {id:'12',label:'Malattie infettive'},
      {id:'13',label:'Medicina e chirurgia di accettazione e di urgenza'},
      {id:'14',label:'Medicina fisica e riabilitazione'},
      {id:'15',label:'Medicina interna'},
      {id:'16',label:'Medicina termale'},
      {id:'17',label:'Medicina aeronautica e spaziale'},
      {id:'18',label:'Medicina dello sport'},
      {id:'19',label:'Nefrologia'},
      {id:'20',label:'Neonatologia'},
      {id:'21',label:'Neurologia'},
      {id:'22',label:'Neuropsichiatria infantile'},
      {id:'23',label:'Oncologia'},
      {id:'24',label:'Pediatria'},
      {id:'25',label:'Psichiatria'},
      {id:'26',label:'Radioterapia'},
      {id:'27',label:'Reumatologia'},
      {id:'29',label:'Cardiochirurgia'},
      {id:'30',label:'Chirurgia generale'},
      {id:'31',label:'Chirurgia maxillo-facciale'},
      {id:'32',label:'Chirurgia pediatrica'},
      {id:'33',label:'Chirurgia plastica e ricostruttiva'},
      {id:'34',label:'Chirurgia toracica'},
      {id:'35',label:'Chirurgia vascolare'},
      {id:'36',label:'Ginecologia e ostetricia'},
      {id:'37',label:'Neurochirurgia'},
      {id:'38',label:'Oftalmologia'},
      {id:'39',label:'Ortopedia e traumatologia'},
      {id:'40',label:'Otorinolaringoiatria'},
      {id:'41',label:'Urologia'},
      {id:'42',label:'Anatomia patologica'},
      {id:'43',label:'Anestesia e rianimazione'},
      {id:'44',label:'Biochimica clinica'},
      {id:'45',label:'Farmacologia e tossicologia clinica'},
      {id:'46',label:'Laboratorio di genetica medica'},
      {id:'47',label:'Medicina trasfusionale'},
      {id:'48',label:'Medicina legale'},
      {id:'49',label:'Medicina nucleare'},
      {id:'50',label:'Microbiologia e virologia'},
      {id:'51',label:'Neurofisiopatologia'},
      {id:'52',label:'Neuroradiologia'},
      {id:'53',label:'Patologia clinica (laboratorio di analisi chimico-cliniche e microbiologia)'},
      {id:'54',label:'Radiodiagnostica'},
      {id:'55',label:'Igiene, epidemiologia e sanità pubblica'},
      {id:'56',label:'Igiene degli alimenti e della nutrizione'},
      {id:'57',label:'Medicina del lavoro e sicurezza degli ambienti di lavoro'},
      {id:'58',label:'Medicina generale (medici di famiglia)'},
      {id:'59',label:'Continuità assistenziale'},
      {id:'60',label:'Pediatria (pediatri di libera scelta)'},
      {id:'106',label:'Scienza dell\'alimentazione e dietetica'},
      {id:'107',label:'Direzione medica di presidio ospedaliero'},
      {id:'108',label:'Organizzazione dei servizi sanitari di base'},
      {id:'111',label:'Audiologia e foniatria'},
      {id:'112',label:'Psicoterapia'},
      {id:'113',label:'Privo di specializzazione'},
      {id:'114',label:'Cure palliative'},
      {id:'115',label:'Epidemiologia'},
      {id:'116',label:'Medicina di comunità'}

            
      
         
         
         ]
         